import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import keys from '@debbie/common/dist/cache/keys.js';
import { BlameLogRefType, BlameLogType, } from '@debbie/common/dist/blamelog/index.js';
import { UpdateState } from '@debbie/common/dist/updates/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import { blameLogs } from '@debbie/cortex/dist/api/index.js';
import * as workflowsAPI from '@debbie/cortex/dist/api/workflows.js';
import { selectUpdateTypesMap } from '@debbie/cortex/dist/update-types/selectors.js';
import { Panel, Button } from '../index.js';
import q from '@debbie/cortex/dist/query.js';
import { caseVouchersEntity } from '@debbie/cortex/dist/case-vouchers/index.js';
import { interactionsByReferenceKey } from '@debbie/cortex/dist/interactions/index.js';
import { Entity } from '@debbie/common/dist/index.js';
const NodeEditorWithCaseContext = (props) => {
    const updateTypesMap = useSelector(selectUpdateTypesMap);
    const lang = useSelector((s) => s.lang);
    const [loading, setLoading] = useState(false);
    const { node } = props;
    const updateType = updateTypesMap[node.data.updateTypeId];
    const executedUpdate = props.caseContext &&
        props.caseContext.updates.find((update) => update.state === UpdateState.Executed && update.taskId === node?.id);
    return (React.createElement(NodeEditorWithCaseContextPanel, null,
        React.createElement("h2", null, lang.updateTypes[updateType.updateTypeId] || updateType.label),
        executedUpdate ? (React.createElement(Button, { loading: loading, block: true, theme: "warning", onClick: async () => {
                try {
                    setLoading(true);
                    await workflowsAPI.rollback(props.caseContext.singleCase.caseId, executedUpdate.updateId);
                    const blameLog = {
                        details: {
                            label: executedUpdate.label,
                            workflowTitle: props.workflow.title,
                        },
                        refId: props.caseContext.singleCase.caseId,
                        refType: BlameLogRefType.Case,
                        type: BlameLogType.WorkflowRollback,
                    };
                    await blameLogs.createBlameLog(blameLog, props.caseContext.singleCase.tenantId);
                    await c.cases.getUpdates(props.caseContext.singleCase.caseId);
                    c.cases.getById(props.caseContext.singleCase.caseId);
                    q.invalidate(keys.write.modify(caseVouchersEntity, ''));
                    q.invalidate([
                        interactionsByReferenceKey(Entity.Case, props.caseContext.singleCase.caseId),
                    ]);
                    props.closeModal();
                }
                catch (error) {
                    alert('Error');
                }
                setLoading(false);
            } }, lang.workflows.rollbackTask)) : (React.createElement(Button, { loading: loading, block: true, onClick: async () => {
                try {
                    setLoading(true);
                    await workflowsAPI.runTask(props.workflow.workflowId, props.caseContext.singleCase.caseId, node.id);
                    await c.cases.getUpdates(props.caseContext.singleCase.caseId);
                    c.cases.getById(props.caseContext.singleCase.caseId);
                    q.invalidate(keys.write.modify(caseVouchersEntity, ''));
                    q.invalidate([
                        interactionsByReferenceKey(Entity.Case, props.caseContext.singleCase.caseId),
                    ]);
                    props.closeModal();
                }
                catch (error) {
                    alert('Error');
                }
                setLoading(false);
            } }, lang.workflows.runTask))));
};
export default NodeEditorWithCaseContext;
const NodeEditorWithCaseContextPanel = styled(Panel) `
  position: absolute;
  width: 300px;
  z-index: 9;
  left: 40px;
  top: 80px;

  .body {
    max-height: calc(100vh - 340px);
    overflow-y: scroll;
  }
`;
//# sourceMappingURL=NodeEditorWithCaseContext.js.map